import FormModal from '../../common/components/FormModal';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/common/utils/Stream';
import BadgeModal from './BadgeModal';
import app from 'flarum/forum/app';
export default class GiveBadgeModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);

    // Select image
    this.selectedBadge = this.attrs.badge ? this.attrs.badge.badge() : null;

    // Current user
    this.user = this.attrs.badge ? this.attrs.badge.user() : this.attrs.user;

    // User has badge
    this.userHasBadge = false;

    // Badge model
    this.badge = this.attrs.badge ? this.attrs.badge : app.store.createRecord('user-badges');

    // Earning reason
    this.description = Stream(this.badge.description());

    // List of available bagges
    this.categories = {};
    this.uncategorizedBadges = [];
    this.loading = false;

    // Load all available badges
    if (!this.attrs.badge) {
      this.loading = true;
      app.store.find('badges', {
        include: 'category'
      }).then(badges => {
        badges.forEach(badge => {
          // Categorized
          if (badge.category()) {
            const category = badge.category();
            if (!this.categories[category.id()]) {
              this.categories[category.id()] = {
                category,
                badges: [badge]
              };
            } else {
              this.categories[category.id()].badges.push(badge);
            }
          }
          // Uncategorized
          else {
            this.uncategorizedBadges.push(badge);
          }
        });
        this.loading = false;

        // Redraw
        m.redraw();
      });
    }
  }
  className() {
    return 'Modal--small BadgeModal';
  }
  title() {
    return app.translator.trans(`v17development-flarum-badges.forum.${this.badge.exists ? 'update' : 'give'}_badge`);
  }
  content() {
    return m("div", null, m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form"
    }, this.fields().toArray())), m("div", {
      className: "Modal-footer"
    }, m(Button, {
      className: 'Button Button--primary',
      type: 'submit',
      loading: this.loading,
      disabled: this.userHasBadge
    }, app.translator.trans('core.forum.composer_edit.submit_button'))));
  }
  fields() {
    const items = new ItemList();

    // Badge selector
    items.add('badge', m("div", {
      className: "BadgeModalListItem"
    }, m("p", null, m("b", null, app.translator.trans('v17development-flarum-badges.forum.badge.badge'))), m("div", {
      className: 'Select'
    }, m("select", {
      value: this.selectedBadge ? this.selectedBadge.id() : 'empty',
      disabled: !!this.attrs.badge,
      onchange: e => {
        if (e.target.value === 'empty') return;
        this.selectedBadge = app.store.getById('badges', e.target.value);

        // Check if the user already has this badge
        this.checkUserHasBadge(this.selectedBadge);
      },
      className: "Select-input FormControl"
    }, m("option", {
      value: 'empty'
    }, app.translator.trans('v17development-flarum-badges.forum.select_badge')), !this.attrs.badge && Object.values(this.categories).map(({
      category,
      badges
    }) => m("optgroup", {
      label: category.name()
    }, badges.map(badge => m("option", {
      value: badge.id()
    }, badge.name())))), !this.attrs.badge && this.uncategorizedBadges.length >= 1 && m("optgroup", {
      label: app.translator.trans('v17development-flarum-badges.forum.uncategorized')
    }, this.uncategorizedBadges.map(badge => m("option", {
      value: badge.id()
    }, badge.name()))), !!this.attrs.badge && m("option", {
      value: this.selectedBadge.id()
    }, this.selectedBadge.name())), m("i", {
      class: "icon fas fa-caret-down Select-caret"
    })), this.userHasBadge && m("p", {
      className: 'UserHasBadge'
    }, app.translator.trans('v17development-flarum-badges.forum.user_has_badge'))), 30);

    // Badge description
    items.add('badge_description', m("div", {
      className: 'BadgeModalListItem'
    }, m("p", null, m("b", null, app.translator.trans('v17development-flarum-badges.forum.badge.description'), ":")), m("p", null, this.selectedBadge ? this.selectedBadge.description() : app.translator.trans('v17development-flarum-badges.forum.select_badge'))), 30);

    // Badge earning reason
    items.add('description', m("div", {
      className: "BadgeModalListItem"
    }, m("p", null, m("b", null, app.translator.trans('v17development-flarum-badges.forum.badge.earning_reason'))), m("textarea", {
      className: "FormControl",
      placeholder: app.translator.trans('v17development-flarum-badges.forum.badge.earning_reason'),
      bidi: this.description
    })), 30);
    return items;
  }
  checkUserHasBadge(badge) {
    let foundBadge = false;
    (this.user.userBadges() || []).map(userBadge => {
      if (userBadge.badge() == badge) {
        foundBadge = true;
      }
    });
    this.userHasBadge = foundBadge;
    m.redraw();
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.badge.save({
      description: this.description(),
      relationships: this.attrs.badge ? {} : {
        badge: this.selectedBadge,
        user: this.user
      }
    }).then(() => {
      // Re-open badge modal
      if (this.attrs.badge) {
        app.modal.show(BadgeModal, {
          badge: this.attrs.badge.badge(),
          userBadgeData: this.attrs.badge
        });
      } else {
        this.hide();
      }
      m.redraw();
    }, response => {
      this.loading = false;
      this.handleErrors(response);
    });
  }
}
flarum.reg.add('itqan-user-badges', 'forum/components/GiveBadgeModal', GiveBadgeModal);